import './styles.scss';
import React, {useRef} from 'react';
import ReactDOM from 'react-dom';
import {
    VIDEO_EMOJI_HEART_EVENT,
    VIDEO_EMOJI_SMILE_EVENT,
    VIDEO_EMOJI_THUMBS_UP_EVENT
} from '../../../constants';
import { PresenceSocketService } from '../../../services/PresenceSocketService';
import { VideoService } from '../../../services/VideoService';
import { ResponsiveService } from '../../../services/ResponsiveService';

export const ReactionButtons = () => {
    ResponsiveService.reactions.ref.panel = useRef();
    return (
        <div className="video-reactions-buttons" ref={ResponsiveService.reactions.ref.panel} tabIndex={0}>
            <button tabIndex={0} className="video-reactions-emojis" aria-label="Smiley face" onClick={() => handleReactionFn(VIDEO_EMOJI_SMILE_EVENT)}>
                &#128515;
            </button>
            <button tabIndex={0} className="video-reactions-emojis" aria-label="Heart" onClick={() => handleReactionFn(VIDEO_EMOJI_HEART_EVENT)}>
                &#10084;&#65039;
            </button>
            <button tabIndex={0} className="video-reactions-emojis" aria-label="Thumbs up" onClick={() => handleReactionFn(VIDEO_EMOJI_THUMBS_UP_EVENT)}>
                &#128077;
            </button>
        </div>
    );
}

export const handleReactionFn = (reaction) => {
    PresenceSocketService.trigger(reaction, { fragmentId: VideoService.currentFragmentId() });
    // Close Reactions panel on mobile
    ResponsiveService.reactions.toggle();
};

const getVideoPlayerRef = () => document.querySelector('.video-js .vjs-control-bar');

const buildContainer = () => {
    const container = document.createElement('div');
    container.className = 'video-emoji-buttons-container';
    return container;
};

const getContainer = () => {
    let container = null;
    const ref = getVideoPlayerRef();
    if (ref) {
        container = buildContainer();
        ref.after(container);
    }
    return container;
}

export const addEmojiButtons = () => { 
    const container = getContainer();

    if (!container) return;

    // Insert buttons in video container
    ReactDOM.render(<ReactionButtons />, container);
};

export const SmileReaction = () => {
    return (
        <p className="video-emoji-animation" role="img" aria-label="Smiley face">&#128515;</p>
    );
}

export const HeartReaction = () => {
    return (
        <p className="video-emoji-animation" role="img" aria-label="Heart">&#10084;&#65039;</p>
    );
}

export const ThumbsUpReaction = () => {
    return (
        <p className="video-emoji-animation" role="img" aria-label="Thumbs up">&#128077;</p>
    );
}
